module.exports = __webpack_public_path__ + "static/media/idli.92eae66d.jpg";